<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('student_clubs')"
                        :isNewButton="checkPermission('studentclub_store')"
                        :isFilter="false"
                        @new-button-click="createFormShow">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('student_clubs')"
                              :isNewButton="checkPermission('studentclub_store')"
                              :isFilter="false"
                              @new-button-click="createFormShow">
                    <div class="mb-1" v-for="(column,key) in datatable.columns">
                        <b-form-checkbox
                            :id="'checkbox-'+key"
                            :name="'checkbox-'+key"
                            :value="false"
                            :unchecked-value="true"
                            v-model="column.hidden"
                            v-if="column.field!='buttons'"
                        >
                            {{ column.label }}
                        </b-form-checkbox>
                    </div>
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
                              :export-excel="checkPermission('studentclub_excelexport')"
                              @exportExcel="downloadExcel"
            >
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group :label="$t('club_name')">
                            <b-form-input v-model="datatable.queryParams.filter.name"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group :label="$t('club_type')">
                            <parameter-selectbox code="student_club_types"
                                v-model="datatable.queryParams.filter.type" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group :label="$t('club_president')">
                            <students-auto-complete-by-key
                                :value="selectedPresident"
                                @user-input="handleSelection">
                            </students-auto-complete-by-key>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group :label="$t('academic_advisor')">
                            <staff-auto-complete v-model="datatable.queryParams.filter.instructor_id"/>
                        </b-form-group>
                    </b-col>
                     <b-col sm="12" md="6">
                        <b-form-group :label="$t('status')">
                            <status-selectbox
                                v-model="datatable.queryParams.filter.status"
                            ></status-selectbox>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>

            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            />
            <CommonModal ref="createFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('studentclub_store')">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess=='create'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="updateFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('studentclub_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess=='update'"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';
    import StatusSelectbox from '@/components/interactive-fields/StatusSelectbox';
    import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';
    import StudentsAutoCompleteByKey from "@/components/interactive-fields/StudentsAutoCompleteByKey"

    //Page
    import CreateForm from './CreateForm'
    import UpdateForm from './UpdateForm'

    //Service
    import StudentClubService from '@/services/StudentClubService';

    //Other
    import qs from 'qs';

    export default {
        components: {
            StudentsAutoCompleteByKey,
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,
            StatusSelectbox,
            ParameterSelectbox,

            CreateForm,
            UpdateForm,
        },
        metaInfo() {
            return {
                title: this.$t('student_clubs')
            }
        },
        data() {
            return {
                formId: 0,
                form: {},
                formProcess: null,
                selectedPresident: '',
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('edit'),
                                    class: 'ri-edit-box-line',
                                    permission: 'studentclub_update',
                                    callback: (row) => {
                                        this.formId = row.id;
                                        this.loadData();
                                    }
                                },
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-2-line',
                                    permission: 'studentclub_delete',
                                    callback: (row) => {
                                        this.delete(row.id);
                                    }
                                }
                            ]
                        },
                        {
                            label: this.toUpperCase('club_name'),
                            field: 'name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('foundation_at'),
                            field: "creation_date",
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('club_type'),
                            field: 'type',
                            formatFn: (row) => {
                                if (row === 'academic') {
                                    return this.$t('academic');
                                } else if (row === 'social_cultural') {
                                    return this.$t('social_cultural');
                                } else if (row === 'sporty') {
                                    return this.$t('sporty');
                                } else {
                                    return '';
                                }
                            },
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('club_president'),
                            field: 'president.name',
                            formatFn: (value, row) => {
                                return `${row.president.name} ${row.president.surname}`;
                            },
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('academic_advisor'),
                            field: 'instructor.name',
                            formatFn: (value, row) => {
                                return `${row.instructor.name} ${row.instructor.surname}`;
                            },
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('status'),
                            field: 'status',
                            hidden: false,
                            formatFn: (row) => {
                                return row == true ? this.$t('active') : this.$t('passive');
                            }
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'name',
                        page: 1,
                        limit: 20
                    }
                }
            };
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.selectedPresident = '';
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const params = { ...this.datatable.queryParams };

                if (params.filter.status) {
                    params.filter = {
                        ...params.filter,
                        status: params.filter.status === 'a' ? '1' : '0'
                    };
                }

                const config = {
                    params,
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return StudentClubService.getAll(config)
                                       .then((response) => {
                                           this.datatable.rows = response.data.data;
                                           this.datatable.total = response.data.pagination.total;
                                       })
                                       .finally(() => {
                                           this.datatable.isLoading = false;
                                       });
            },
            loadData() {
                this.formProcess = 'update';
                StudentClubService.get(this.formId)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.$refs.updateFormModal.$refs.commonModal.show();
                                })
                                .catch((error) => {
                                    if (error.data.message) {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    }
                                });
            },
            delete(id) {
                this.deleteModal(() => {
                    StudentClubService.del(id)
                                    .then((response) => {
                                        this.filter();
                                        this.$toast.success(this.$t('api.' + response.data.message));
                                    })
                                    .catch((error) => {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    });
                });
            },
            async createFormSuccess() {
                this.$refs.createFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            async updateFormSuccess() {
                this.$refs.updateFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            createFormShow() {
                this.formId = null
                this.form = {};
                this.formProcess = 'create'
                this.$refs.createFormModal.$refs.commonModal.show()
            },
            formClear() {
                this.formId = null
                this.formProcess = null
            },
            downloadExcel() {
                const params = { ...this.datatable.queryParams };

                if (params.filter && params.filter.status !== undefined && params.filter.status !== null && params.filter.status !== '') {
                    const s = params.filter.status;
                    params.filter = {
                        ...params.filter,
                        status: s === 'a' || s === true ? '1' : '0'
                    };
                }

                const config = {
                    params,
                    paramsSerializer: (params) => qs.stringify(params, { encode: false })
                };


                StudentClubService.downloadAsExcel(config)
                    .then(res => this._downloadFile(res, this.$t('student_clubs') + '.xlsx'))
                    .catch(err => this.showErrors(err))
            },
            handleSelection(user) {
                this.form.president_id = user?.user_id;
                this.selectedPresident = user ? `${user.name} ${user.surname}` : '';
                this.datatable.queryParams.filter.president_id = user?.user_id || null;
            }
        }
    }
</script>
